import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    effect,
    inject,
    signal,
    Type,
    input,
} from '@angular/core';
import { IAttachment } from '@dxp/core/models';
import {
    IPreviewContext,
    TelXLContentPreviewService,
} from './services/content-preview.service';

@Component({
    selector: 'telxl-shared-content-preview-inline',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    template: `
        @if (comp()) {
            <ng-container
                *ngComponentOutlet="comp(); inputs: { context: ctx() }"
            ></ng-container>
        } @else {
            <div class="text-muted small">No preview available.</div>
        }
    `,
})
export class TelXLContentPreviewInlineComponent {
    readonly #destroyRef = inject(DestroyRef);
    readonly #preview = inject(TelXLContentPreviewService);

    file = input.required<IAttachment>();

    comp = signal<Type<any> | null>(null);
    ctx = signal<IPreviewContext>({
        url: '',
        contentType: '',
        fileName: 'Preview',
    } as IPreviewContext);

    constructor() {
        effect(() => {
            const f = this.file();
            if (!f) {
                this.comp.set(null);
                return;
            }

            let cancelled = false;
            this.#preview
                .resolveForInline({
                    fileName: f.name,
                    url: f.contentUrl,
                    contentType: f.contentType,
                })
                .then(({ component, ctx }) => {
                    if (cancelled) return;
                    this.comp.set(component);
                    this.ctx.set(ctx);
                });

            this.#destroyRef.onDestroy(() => {
                cancelled = true;
            });
        });
    }
}
